import type { FaireProductEntity } from "../../entity_types/product";

export const p_bjp7bgrtxz: FaireProductEntity = {
  token: "p_bjp7bgrtxz",
  type: "product",
  name: "Hinoki Sesame Candle",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/311e00018a6aa1be9db8f2b91f27d91f378c38b487ba2674cd11ac2db0bea0f0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ddff07f1acf94d52bfc5c38ceeed6c090cde83d74292bc5ec3b01056362c761.jpeg",
    "https://cdn.faire.com/fastly/58390a4c0973ea14ae2834e42a994fc48b266086f78d5502d6094c5976ed9606.png",
    "https://cdn.faire.com/fastly/18add049daaa5314226c465ad318a4726baf50a5483f9c06c100feba835039af.jpeg",
    "https://cdn.faire.com/fastly/56c98f511ec07567461cd1967886489cf6b146c2260da15bf10d83c3ae1c1fc0.png",
  ],
  priceDollars: 16,
  description:
    "dilo candles are hand poured and made using 100% USA grown Soy Wax. \n\nDesigned and poured at dilo Studios in Philadelphia.\n\nTop Notes: bergamot, lemon peel, cedar leaf\nHeart: sea salt, incense smoke, sesame seeds, sandalwood\nBase: hinoki, red cedar, musk\n\n8.5 ounces - Burns 45 Hours\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n",
  tags: [],
  msrpDollars: 32,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:01.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
